export const LOAD_BOOK_BACKGROUND = "LOAD_BOOK_BACKGROUND";
export const RESET_BOOK_BACKGROUND = "RESET_BOOK_BACKGROUND";